/* tslint:disable */
/* eslint-disable */
/**
 * Data Processor
 * NextUp Data processor
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@nextupsoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ListNotifications200Response } from '../models';
// @ts-ignore
import type { Notification } from '../models';
// @ts-ignore
import type { PartialNotification } from '../models';
/**
 * NotificationsApi - axios parameter creator
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Notification} [notification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification: async (notification?: Notification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [inputConnectorId] input_connector_id
         * @param {string} [inputRecordId] input_record_id
         * @param {string} [inputRecordRowId] input_record_row_id
         * @param {string} [inputRecordGroupId] input_record_group_id
         * @param {string} [type] type
         * @param {string} [all] all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyNotification: async (id: string, inputConnectorId?: string, inputRecordId?: string, inputRecordRowId?: string, inputRecordGroupId?: string, type?: string, all?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyNotification', 'id', id)
            const localVarPath = `/api/notifications/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (inputConnectorId !== undefined) {
                localVarQueryParameter['input_connector_id'] = inputConnectorId;
            }

            if (inputRecordId !== undefined) {
                localVarQueryParameter['input_record_id'] = inputRecordId;
            }

            if (inputRecordRowId !== undefined) {
                localVarQueryParameter['input_record_row_id'] = inputRecordRowId;
            }

            if (inputRecordGroupId !== undefined) {
                localVarQueryParameter['input_record_group_id'] = inputRecordGroupId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [inputConnectorId] input_connector_id
         * @param {string} [inputRecordId] input_record_id
         * @param {string} [inputRecordRowId] input_record_row_id
         * @param {string} [inputRecordGroupId] input_record_group_id
         * @param {string} [type] type
         * @param {string} [all] all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotifications: async (page?: number, inputConnectorId?: string, inputRecordId?: string, inputRecordRowId?: string, inputRecordGroupId?: string, type?: string, all?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (inputConnectorId !== undefined) {
                localVarQueryParameter['input_connector_id'] = inputConnectorId;
            }

            if (inputRecordId !== undefined) {
                localVarQueryParameter['input_record_id'] = inputRecordId;
            }

            if (inputRecordRowId !== undefined) {
                localVarQueryParameter['input_record_row_id'] = inputRecordRowId;
            }

            if (inputRecordGroupId !== undefined) {
                localVarQueryParameter['input_record_group_id'] = inputRecordGroupId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [inputConnectorId] input_connector_id
         * @param {string} [inputRecordId] input_record_id
         * @param {string} [inputRecordRowId] input_record_row_id
         * @param {string} [inputRecordGroupId] input_record_group_id
         * @param {string} [type] type
         * @param {string} [all] all
         * @param {PartialNotification} [partialNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateNotification: async (id: string, inputConnectorId?: string, inputRecordId?: string, inputRecordRowId?: string, inputRecordGroupId?: string, type?: string, all?: string, partialNotification?: PartialNotification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partialUpdateNotification', 'id', id)
            const localVarPath = `/api/notifications/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (inputConnectorId !== undefined) {
                localVarQueryParameter['input_connector_id'] = inputConnectorId;
            }

            if (inputRecordId !== undefined) {
                localVarQueryParameter['input_record_id'] = inputRecordId;
            }

            if (inputRecordRowId !== undefined) {
                localVarQueryParameter['input_record_row_id'] = inputRecordRowId;
            }

            if (inputRecordGroupId !== undefined) {
                localVarQueryParameter['input_record_group_id'] = inputRecordGroupId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialNotification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [inputConnectorId] input_connector_id
         * @param {string} [inputRecordId] input_record_id
         * @param {string} [inputRecordRowId] input_record_row_id
         * @param {string} [inputRecordGroupId] input_record_group_id
         * @param {string} [type] type
         * @param {string} [all] all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveNotification: async (id: string, inputConnectorId?: string, inputRecordId?: string, inputRecordRowId?: string, inputRecordGroupId?: string, type?: string, all?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveNotification', 'id', id)
            const localVarPath = `/api/notifications/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (inputConnectorId !== undefined) {
                localVarQueryParameter['input_connector_id'] = inputConnectorId;
            }

            if (inputRecordId !== undefined) {
                localVarQueryParameter['input_record_id'] = inputRecordId;
            }

            if (inputRecordRowId !== undefined) {
                localVarQueryParameter['input_record_row_id'] = inputRecordRowId;
            }

            if (inputRecordGroupId !== undefined) {
                localVarQueryParameter['input_record_group_id'] = inputRecordGroupId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [inputConnectorId] input_connector_id
         * @param {string} [inputRecordId] input_record_id
         * @param {string} [inputRecordRowId] input_record_row_id
         * @param {string} [inputRecordGroupId] input_record_group_id
         * @param {string} [type] type
         * @param {string} [all] all
         * @param {Notification} [notification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification: async (id: string, inputConnectorId?: string, inputRecordId?: string, inputRecordRowId?: string, inputRecordGroupId?: string, type?: string, all?: string, notification?: Notification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNotification', 'id', id)
            const localVarPath = `/api/notifications/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (inputConnectorId !== undefined) {
                localVarQueryParameter['input_connector_id'] = inputConnectorId;
            }

            if (inputRecordId !== undefined) {
                localVarQueryParameter['input_record_id'] = inputRecordId;
            }

            if (inputRecordRowId !== undefined) {
                localVarQueryParameter['input_record_row_id'] = inputRecordRowId;
            }

            if (inputRecordGroupId !== undefined) {
                localVarQueryParameter['input_record_group_id'] = inputRecordGroupId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Notification} [notification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotification(notification?: Notification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotification(notification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.createNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [inputConnectorId] input_connector_id
         * @param {string} [inputRecordId] input_record_id
         * @param {string} [inputRecordRowId] input_record_row_id
         * @param {string} [inputRecordGroupId] input_record_group_id
         * @param {string} [type] type
         * @param {string} [all] all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyNotification(id: string, inputConnectorId?: string, inputRecordId?: string, inputRecordRowId?: string, inputRecordGroupId?: string, type?: string, all?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyNotification(id, inputConnectorId, inputRecordId, inputRecordRowId, inputRecordGroupId, type, all, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.destroyNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [inputConnectorId] input_connector_id
         * @param {string} [inputRecordId] input_record_id
         * @param {string} [inputRecordRowId] input_record_row_id
         * @param {string} [inputRecordGroupId] input_record_group_id
         * @param {string} [type] type
         * @param {string} [all] all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotifications(page?: number, inputConnectorId?: string, inputRecordId?: string, inputRecordRowId?: string, inputRecordGroupId?: string, type?: string, all?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNotifications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotifications(page, inputConnectorId, inputRecordId, inputRecordRowId, inputRecordGroupId, type, all, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.listNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [inputConnectorId] input_connector_id
         * @param {string} [inputRecordId] input_record_id
         * @param {string} [inputRecordRowId] input_record_row_id
         * @param {string} [inputRecordGroupId] input_record_group_id
         * @param {string} [type] type
         * @param {string} [all] all
         * @param {PartialNotification} [partialNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partialUpdateNotification(id: string, inputConnectorId?: string, inputRecordId?: string, inputRecordRowId?: string, inputRecordGroupId?: string, type?: string, all?: string, partialNotification?: PartialNotification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialNotification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partialUpdateNotification(id, inputConnectorId, inputRecordId, inputRecordRowId, inputRecordGroupId, type, all, partialNotification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.partialUpdateNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [inputConnectorId] input_connector_id
         * @param {string} [inputRecordId] input_record_id
         * @param {string} [inputRecordRowId] input_record_row_id
         * @param {string} [inputRecordGroupId] input_record_group_id
         * @param {string} [type] type
         * @param {string} [all] all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveNotification(id: string, inputConnectorId?: string, inputRecordId?: string, inputRecordRowId?: string, inputRecordGroupId?: string, type?: string, all?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveNotification(id, inputConnectorId, inputRecordId, inputRecordRowId, inputRecordGroupId, type, all, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.retrieveNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [inputConnectorId] input_connector_id
         * @param {string} [inputRecordId] input_record_id
         * @param {string} [inputRecordRowId] input_record_row_id
         * @param {string} [inputRecordGroupId] input_record_group_id
         * @param {string} [type] type
         * @param {string} [all] all
         * @param {Notification} [notification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotification(id: string, inputConnectorId?: string, inputRecordId?: string, inputRecordRowId?: string, inputRecordGroupId?: string, type?: string, all?: string, notification?: Notification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotification(id, inputConnectorId, inputRecordId, inputRecordRowId, inputRecordGroupId, type, all, notification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {NotificationsApiCreateNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(requestParameters: NotificationsApiCreateNotificationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Notification> {
            return localVarFp.createNotification(requestParameters.notification, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiDestroyNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyNotification(requestParameters: NotificationsApiDestroyNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.destroyNotification(requestParameters.id, requestParameters.inputConnectorId, requestParameters.inputRecordId, requestParameters.inputRecordRowId, requestParameters.inputRecordGroupId, requestParameters.type, requestParameters.all, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiListNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotifications(requestParameters: NotificationsApiListNotificationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListNotifications200Response> {
            return localVarFp.listNotifications(requestParameters.page, requestParameters.inputConnectorId, requestParameters.inputRecordId, requestParameters.inputRecordRowId, requestParameters.inputRecordGroupId, requestParameters.type, requestParameters.all, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiPartialUpdateNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateNotification(requestParameters: NotificationsApiPartialUpdateNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartialNotification> {
            return localVarFp.partialUpdateNotification(requestParameters.id, requestParameters.inputConnectorId, requestParameters.inputRecordId, requestParameters.inputRecordRowId, requestParameters.inputRecordGroupId, requestParameters.type, requestParameters.all, requestParameters.partialNotification, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiRetrieveNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveNotification(requestParameters: NotificationsApiRetrieveNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Notification> {
            return localVarFp.retrieveNotification(requestParameters.id, requestParameters.inputConnectorId, requestParameters.inputRecordId, requestParameters.inputRecordRowId, requestParameters.inputRecordGroupId, requestParameters.type, requestParameters.all, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationsApiUpdateNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification(requestParameters: NotificationsApiUpdateNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Notification> {
            return localVarFp.updateNotification(requestParameters.id, requestParameters.inputConnectorId, requestParameters.inputRecordId, requestParameters.inputRecordRowId, requestParameters.inputRecordGroupId, requestParameters.type, requestParameters.all, requestParameters.notification, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createNotification operation in NotificationsApi.
 */
export interface NotificationsApiCreateNotificationRequest {
    readonly notification?: Notification
}

/**
 * Request parameters for destroyNotification operation in NotificationsApi.
 */
export interface NotificationsApiDestroyNotificationRequest {
    /**
     * 
     */
    readonly id: string

    /**
     * input_connector_id
     */
    readonly inputConnectorId?: string

    /**
     * input_record_id
     */
    readonly inputRecordId?: string

    /**
     * input_record_row_id
     */
    readonly inputRecordRowId?: string

    /**
     * input_record_group_id
     */
    readonly inputRecordGroupId?: string

    /**
     * type
     */
    readonly type?: string

    /**
     * all
     */
    readonly all?: string
}

/**
 * Request parameters for listNotifications operation in NotificationsApi.
 */
export interface NotificationsApiListNotificationsRequest {
    /**
     * A page number within the paginated result set.
     */
    readonly page?: number

    /**
     * input_connector_id
     */
    readonly inputConnectorId?: string

    /**
     * input_record_id
     */
    readonly inputRecordId?: string

    /**
     * input_record_row_id
     */
    readonly inputRecordRowId?: string

    /**
     * input_record_group_id
     */
    readonly inputRecordGroupId?: string

    /**
     * type
     */
    readonly type?: string

    /**
     * all
     */
    readonly all?: string
}

/**
 * Request parameters for partialUpdateNotification operation in NotificationsApi.
 */
export interface NotificationsApiPartialUpdateNotificationRequest {
    /**
     * 
     */
    readonly id: string

    /**
     * input_connector_id
     */
    readonly inputConnectorId?: string

    /**
     * input_record_id
     */
    readonly inputRecordId?: string

    /**
     * input_record_row_id
     */
    readonly inputRecordRowId?: string

    /**
     * input_record_group_id
     */
    readonly inputRecordGroupId?: string

    /**
     * type
     */
    readonly type?: string

    /**
     * all
     */
    readonly all?: string

    readonly partialNotification?: PartialNotification
}

/**
 * Request parameters for retrieveNotification operation in NotificationsApi.
 */
export interface NotificationsApiRetrieveNotificationRequest {
    /**
     * 
     */
    readonly id: string

    /**
     * input_connector_id
     */
    readonly inputConnectorId?: string

    /**
     * input_record_id
     */
    readonly inputRecordId?: string

    /**
     * input_record_row_id
     */
    readonly inputRecordRowId?: string

    /**
     * input_record_group_id
     */
    readonly inputRecordGroupId?: string

    /**
     * type
     */
    readonly type?: string

    /**
     * all
     */
    readonly all?: string
}

/**
 * Request parameters for updateNotification operation in NotificationsApi.
 */
export interface NotificationsApiUpdateNotificationRequest {
    /**
     * 
     */
    readonly id: string

    /**
     * input_connector_id
     */
    readonly inputConnectorId?: string

    /**
     * input_record_id
     */
    readonly inputRecordId?: string

    /**
     * input_record_row_id
     */
    readonly inputRecordRowId?: string

    /**
     * input_record_group_id
     */
    readonly inputRecordGroupId?: string

    /**
     * type
     */
    readonly type?: string

    /**
     * all
     */
    readonly all?: string

    readonly notification?: Notification
}

/**
 * NotificationsApi - object-oriented interface
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @param {NotificationsApiCreateNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createNotification(requestParameters: NotificationsApiCreateNotificationRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).createNotification(requestParameters.notification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiDestroyNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public destroyNotification(requestParameters: NotificationsApiDestroyNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).destroyNotification(requestParameters.id, requestParameters.inputConnectorId, requestParameters.inputRecordId, requestParameters.inputRecordRowId, requestParameters.inputRecordGroupId, requestParameters.type, requestParameters.all, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiListNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listNotifications(requestParameters: NotificationsApiListNotificationsRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).listNotifications(requestParameters.page, requestParameters.inputConnectorId, requestParameters.inputRecordId, requestParameters.inputRecordRowId, requestParameters.inputRecordGroupId, requestParameters.type, requestParameters.all, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiPartialUpdateNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public partialUpdateNotification(requestParameters: NotificationsApiPartialUpdateNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).partialUpdateNotification(requestParameters.id, requestParameters.inputConnectorId, requestParameters.inputRecordId, requestParameters.inputRecordRowId, requestParameters.inputRecordGroupId, requestParameters.type, requestParameters.all, requestParameters.partialNotification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiRetrieveNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveNotification(requestParameters: NotificationsApiRetrieveNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).retrieveNotification(requestParameters.id, requestParameters.inputConnectorId, requestParameters.inputRecordId, requestParameters.inputRecordRowId, requestParameters.inputRecordGroupId, requestParameters.type, requestParameters.all, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationsApiUpdateNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateNotification(requestParameters: NotificationsApiUpdateNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateNotification(requestParameters.id, requestParameters.inputConnectorId, requestParameters.inputRecordId, requestParameters.inputRecordRowId, requestParameters.inputRecordGroupId, requestParameters.type, requestParameters.all, requestParameters.notification, options).then((request) => request(this.axios, this.basePath));
    }
}

